import moment from "moment-timezone";
const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
export const truncateText = (text, maxLength) => {
  if (!text) return '';
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
};
export const getFullName = (FirstName = "", LastName = "") => {
  return `${FirstName || "-"} ${LastName || "-"} `
}
//  get value if value is coming array for payload
export const getValue = (data, key = "value") => data[0]?.[key]

export const combineDateAndTimeToUTC = (date, time) => {
  if (!date || !time) return null;

  // Extract date and time parts correctly
  const datePart = moment.utc(date).format("YYYY-MM-DD");
  const timePart = moment.utc(time).format("HH:mm");

  // Combine date and time, convert to UTC
  const dateTimeUTC = moment.utc(`${datePart} ${timePart}`, "YYYY-MM-DD HH:mm").format();

  return dateTimeUTC;
};
export const onSort = (columnKey = null, sortConfig, setSortConfig) => {
  let direction = -1;
  if (sortConfig.sortValue === columnKey) {
    direction = sortConfig.sortOrder === 1 ? -1 : 1;
  }
  setSortConfig((prev) => ({
    ...prev,
    sortValue: columnKey,
    sortOrder: direction,

  }));
};

export const handleTrimmedValue = (value = "") => {
  const isTrimmedEmpty = typeof value === "string" && value?.trim()?.length === 0;
  return isTrimmedEmpty ? value?.trim() : value;
};

export const getLocalizedText = (item, key, isEnglish) => {
  return isEnglish ? item?.[key] : item?.[`${key}_ar`] || item?.[key];
};

export function extractCity(addressComponents) {
  if (!addressComponents) return "";
  const locality = addressComponents.find(c => c.types.includes("locality"));
  if (locality) return locality.long_name;
  const adminArea = addressComponents.find(c => c.types.includes("administrative_area_level_1"));
  if (adminArea) return adminArea.long_name;
  const adminArea2 = addressComponents.find(c => c.types.includes("administrative_area_level_2"));
  if (adminArea2) return adminArea2.long_name;
  return "";
}

export const TIMEZONE = () => {
  if (timeZone === "Asia/Calcutta" || timeZone === "Asia/Kolkata") {
    let indiaTimezone = "Asia/Kolkata"
    return indiaTimezone
  } else {
    return timeZone
  }
}


export function generateId() {
  return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
}
